import Vue from 'vue';

function isCssColor(color: string) {
  return !!color && !!color.match(/^(#|(rgb|hsl)a?\()/);
}

export default Vue.extend({
  name: 'Inputable',
  props: {
    color: { default: 'surface-1', type: String },
    textColor: { default: undefined, type: String },
  },
  methods: {
    getAllColors() {
      const data = { style: {} as Record<string, string>, class: {} as Record<string, boolean> };
      const backgroundData = this.getBackgroundColor();
      const borderData = this.getBorderColor();
      const textData = this.getTextColor();
      data.style = { ...backgroundData.style, ...borderData.style, ...textData.style };
      data.class = { ...backgroundData.class, ...borderData.class, ...textData.class };
      return data;
    },
    getBorderColor() {
      const data = { style: {} as Record<string, string>, class: {} as Record<string, boolean> };
      data.style = {};
      data.class = {};
      if (isCssColor(this.color)) {
        data.style['border-color'] = `${this.color}`;
      } else if (this.color) {
        data.class[`border-color-${this.color}`] = true;
      }
      return data;
    },
    getBackgroundColor() {
      const data = { style: {} as Record<string, string>, class: {} as Record<string, boolean> };
      data.style = {};
      data.class = {};
      if (isCssColor(this.color)) {
        data.style['background-color'] = `${this.color}`;
      } else if (this.color) {
        data.class[`color-${this.color}`] = true;
      }
      return data;
    },
    getTextColor() {
      const data = { style: {} as Record<string, string>, class: {} as Record<string, boolean> };
      data.style = {};
      data.class = {};
      if (isCssColor(this.textColor)) {
        data.style.color = `${this.textColor} !important`;
        data.style['caret-color'] = `${this.textColor} !important`;
      } else if (this.textColor) {
        data.class[`text-color-${this.textColor}`] = true;
      }

      return data;
    },
  },
});
